import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead,
  findRouteByName,
} from "@/libs/util";
import beforeClose from "@/router/before-close";
import router from "@/router";
import routers from "@/router/routers";
import config from "@/config";
import { curLan, setCurLan ,setCurLanI18n,getI18nLang} from "@/utils/language";
import api from "@/api";
import langmap from '@/utils/language';
import Vue from 'vue';
import i18n from '@/locale';

const { homeName } = config;

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route);
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route);
  });
  router.push(nextRoute);
};

// 处理菜单
function setMenuData(ajaxMenu) {
  var endAllowArray = ["home"];
  for (var i = 0; i < ajaxMenu.length; i++) {
    ajaxMenu[i].meta = {
      hideInMenu: true,
      notCache: true,
      title: ajaxMenu[i].title
    };
    endAllowArray.push(ajaxMenu[i].name);
    for (var j = 0; j < ajaxMenu[i].children.length; j++) {
      ajaxMenu[i].children[j].meta = {
        hideInMenu: true,
        notCache: true,
        title: ajaxMenu[i].children[j].title
      };
      endAllowArray.push(ajaxMenu[i].children[j].name);
    }
  }
  //写入组件
  //允许访问的菜单存入缓存
  var endAllowArrayStr = endAllowArray.join("|");
  //保存允许访问的菜单
  localStorage.setItem("menulist", endAllowArrayStr);
  return ajaxMenu;
}

export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: localRead("local"),
    errorList: [],
    hasReadErrorPage: false,
    //动态权限后台返回的菜单
    sysMenulist: [],
    //配置不需要验证的菜单数组
    notCheckMenulist: ["home", "login", "error_401", "error_500", "error_404", "debug-tools"],
    // 地图各类型区域颜色：红、绿、黄、红、蓝
    mapAreaColor: ["#C11515", "#178229", "#CABB1C","#C11515","#005dbe"],
    // 地图相关配置
    mapConfig: {
      areaColor: ["#C11515", "#178229", "#CABB1C","#C11515","#005dbe"],
      trackColor: "#596164",
      trackWidth: 4,
      center: [115.044767, 30.338292], //[120.126921, 30.272823]
      center1: [30.338292, 115.044767] //leaflet
    },
    //地图配置
    leafletConfig:{
      mapInstantiated:{
        center: [30.272823, 120.126921],//地图初始中心点坐标，格式为 [纬度, 经度]
        zoom: 18,//地图初始缩放级别（数字越大越详细）
        zoomControl: true,//是否显示缩放控件（+/- 按钮）
        doubleClickZoom: true,//是否启用双击缩放功能
        attributionControl: false//是否显示版权归属信息控件
      },
      tileLayerOption:{
        url: '', // 地图瓦片服务的 URL 地址（当前为空，注释显示高德地图URL已移除）
        minZoom: 7,//地图最小缩放级别
        maxZoom: 29,//地图最大缩放级别
        maxNativeZoom: 18//瓦片图层本身支持的最大原生缩放级别，超过此级别会自动放大已有瓦片
      }
    },
    // 当前语言
    language: curLan
  },
  getters: {
    menuList: (state, getters, rootState) =>
      getMenuByRouter(routers, rootState.user.access),
    errorCount: state => state.errorList.length
  },
  mutations: {
    //处理菜单数据并更新
    updateMenulist(state, ajaxMenu) {
      setMenuData(ajaxMenu);
      state.sysMenulist = ajaxMenu;
    },
    // 设置当前语言
    setLanguage(state,params) {
      const { language, route } = params;

      state.language = language;
      setCurLan(language);
      // 更新i18n的格式
      setCurLanI18n(language);
      // 更新浏览器标题
      document.title = langmap.title[language]
      // 更新Vue.config.lang 和i18n.locale
      let i18nLang = getI18nLang(language);
      Vue.config.lang = i18nLang;
      i18n.locale = i18nLang;
      // 重新请求菜单
      api.getData("system-server/user/get/home/date").then(res => {
        if (res.state === 0) return;
        const menus = setMenuData(res.data.menu);
        state.sysMenulist = menus;
        // 重新设置 homeRoute
        this.commit('setHomeRoute', routers);
        // 切换tag的 title language。
        this.commit('setTagNavList');
        this.commit('setBreadCrumb', route);
      });
    },
    setBreadCrumb(state, route) {
      const _routes = getBreadCrumbList(route, state.homeRoute);
      // title language更新
      _routes.forEach(item => {
        if (item.meta && item.meta.title) {
          const _routeItem = findRouteByName(state.sysMenulist, item.name);
          _routeItem && (item.meta.title = _routeItem.title);
        }
      });
      state.breadCrumbList = _routes;
    },
    setHomeRoute(state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName);
    },
    setTagNavList(state, list) {
      let tagList = [];
      if (list) {
        tagList = [...list];
      } else tagList = getTagNavListFromLocalstorage() || [];
      if (tagList[0] && tagList[0].name !== homeName) tagList.shift();
      // title language更新
      tagList.forEach(item => {
        if (item.meta && item.meta.title) {
          const _routeItem = findRouteByName(state.sysMenulist, item.name);
          _routeItem && (item.meta.title = _routeItem.title);
        }
      });

      let homeTagIndex = tagList.findIndex(item => item.name === homeName);
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0];
        tagList.unshift(homeTag);
      }
      state.tagNavList = tagList;
      setTagNavListInLocalstorage([...tagList]);
    },
    closeTag(state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route));
      route = tag[0] ? tag[0] : null;
      if (!route) return;
      if (
        route.meta &&
        route.meta.beforeCloseName &&
        route.meta.beforeCloseName in beforeClose
      ) {
        new Promise(beforeClose[route.meta.beforeCloseName]).then(close => {
          if (close) {
            closePage(state, route);
          }
        });
      } else {
        closePage(state, route);
      }
    },
    addTag(state, { route, type = "unshift" }) {
      let router = getRouteTitleHandled(route);

      if (!routeHasExist(state.tagNavList, router)) {
        const routeItem = findRouteByName(state.sysMenulist, router.name);
        // 同步 title的语言
        routeItem && router.meta && (router.meta.title = routeItem.title);
        if (type === "push") state.tagNavList.push(router);
        else {
          if (router.name === homeName) state.tagNavList.unshift(router);
          else state.tagNavList.splice(1, 0, router);
        }
        setTagNavListInLocalstorage([...state.tagNavList]);
      }
    },
    setLocal(state, lang) {
      localSave("local", lang);
      state.local = lang;
    },
    addError(state, error) {
      state.errorList.push(error);
    },
    setHasReadErrorLoggerStatus(state, status = true) {
      state.hasReadErrorPage = status;
    },
    // 更新leaflet地图配置
    updateMapInstantiated(state, config) {
      state.leafletConfig.mapInstantiated = { ...state.leafletConfig.mapInstantiated, ...config };
    },
    updateTileLayerOption(state, config) {
      state.leafletConfig.tileLayerOption = { ...state.leafletConfig.tileLayerOption, ...config };
    },
    // 更新leaflet地图Url
    updateLeafletUrl(state, val) {
      console.log(2)
      state.leafletConfig.tileLayerOption.url = val;
    }
  },
  actions: {
    addErrorLog({ commit, rootState }, info) {
      if (!window.location.href.includes("error_logger_page"))
        commit("setHasReadErrorLoggerStatus", false);
      const {
        user: { token, userId, userName }
      } = rootState;
      let data = {
        ...info,
        time: Date.parse(new Date()),
        token,
        userId,
        userName
      };
    },
    // 加载 leaflet 地图配置
    loadLeafletConfig({ commit }) {
      return api.getData("system-server/config/list?keys=leafletConfig,defaultMapUrl").then(r => {
        if (r.state == 0) {
          console.error('获取leafletConfig配置失败:', r.msg);
          return Promise.reject(r.msg);
        } else {
          let config = r.data['leafletConfig'];
          let mapUrlData = r.data['defaultMapUrl'];
          if (config && config.configValue) {
            try {
              // 解析JSON配置
              const leafletConfig = JSON.parse(config.configValue);
              // 更新到store中的leafletConfig
              commit('updateMapInstantiated', leafletConfig.mapInstantiated);
              commit('updateTileLayerOption', leafletConfig.tileLayerOption);
              if(!leafletConfig.tileLayerOption || !leafletConfig.tileLayerOption.url){
                // 加载默认地图URL
                if (mapUrlData && mapUrlData.configValue) {
                  commit('updateLeafletUrl', mapUrlData.configValue);
                }
              }
            } catch (error) {
              console.error('解析leafletConfig配置失败:', error);
              // 如果解析失败，尝试获取默认地图URL
              if (mapUrlData && mapUrlData.configValue) {
                commit('updateLeafletUrl', mapUrlData.configValue);
              }
            }
          } else {
            // 如果没有leafletConfig配置，尝试获取默认地图URL
            if (mapUrlData && mapUrlData.configValue) {
              commit('updateLeafletUrl', mapUrlData.configValue);
            }
          }
          return Promise.resolve();
        }
      }).catch(error => {
        console.error('请求leafletConfig配置失败:', error);
        return Promise.reject(error);
      });
    }
  }
};
